import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import JsonLd from "@/components/feature/JsonLd";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import RankingSection from "./components/RankingSection";
import MangaGrid from "./components/MangaGrid";
import ArticleList from "./components/ArticleList";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

const BASE_URL = "https://mangistart.github.io";

export default function Home() {
  return (
    <>
      <Seo
        title="漫画分类大全导航 - 漫画类型大全、漫画题材分类、漫画排行榜大全"
        description="汇集漫画分类大全与漫画类型大全，按题材分类整理漫画推荐大全，并附漫画排行榜大全与漫画人气排行，帮你快速找到想看的漫画。"
        keywords="漫画分类大全,漫画类型大全,漫画题材分类,漫画排行榜大全,漫画人气排行,漫画推荐大全"
      />
      <JsonLd
        data={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "漫途导航 · 漫画分类大全",
            url: BASE_URL,
            logo: `${BASE_URL}/logo.png`,
            description: "漫画分类大全导航平台，汇集漫画类型大全、漫画题材分类、漫画排行榜大全与漫画推荐大全。",
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+86-400-888-9999",
              contactType: "customer service",
              areaServed: "CN",
              availableLanguage: ["中文"],
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "漫画分类大全导航",
            url: BASE_URL,
            description: "漫画分类大全与漫画类型大全导航，漫画排行榜大全与人气排行。",
            inLanguage: "zh-CN",
          },
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "漫画分类大全导航",
            url: `${BASE_URL}/`,
            isPartOf: { "@type": "WebSite", name: "漫途导航", url: BASE_URL },
            about: "漫画分类大全",
            inLanguage: "zh-CN",
          },
        ]}
      />
      <div className="flex min-h-screen flex-col bg-background-50">
        <Navbar />
        <main className="flex-1">
          <Hero />
          <CategoryGrid />
          <RankingSection />
          <MangaGrid />
          <ArticleList />
          <FaqSection />
          <CtaSection />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </>
  );
}